import React from 'react';
import clsx from 'clsx';
import Edit from "../../icons/Edit";

import { Button } from '..';
import { createStyles } from "./styles";

var EditableInfoBlock = function EditableInfoBlock(_ref)




{var title = _ref.title,onEditInfo = _ref.onEditInfo,_ref$width = _ref.width,width = _ref$width === void 0 ? '' : _ref$width,_ref$wrapperStyle = _ref.wrapperStyle,wrapperStyle = _ref$wrapperStyle === void 0 ? '' : _ref$wrapperStyle;
  var classes = createStyles(width);
  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.effectiveDateInfo, wrapperStyle) }, /*#__PURE__*/
    React.createElement("span", null, title), /*#__PURE__*/
    React.createElement(Button, { type: "icon", onClick: onEditInfo, color: "primary", className: classes.editButton }, /*#__PURE__*/
    React.createElement(Edit, { width: "2rem" }))));



};

export default EditableInfoBlock;
//# sourceMappingURL=index.js.map